import { EnumRichiestaDTOStatoOneri } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaDTOStatoOneri.ts';
import { type RichiestaDTOStatoOneri } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTOStatoOneri.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { type TagProps } from 'antd';
import { type DefaultTheme, useTheme } from 'styled-components';

function getTagOptions(
  state: RichiestaDTOStatoOneri,
  theme?: DefaultTheme,
): TagProps {
  if (state == null) return { hidden: true };
  const text = state.replace('_', ' ');
  switch (state) {
    case EnumRichiestaDTOStatoOneri.DA_PAGARE:
      return {
        color: '#9E6C00', // theme?.colorWarning,
        children: text,
      };
    case EnumRichiestaDTOStatoOneri.PAGATO:
      return {
        color: theme?.colorSuccess,
        children: text,
      };
    case EnumRichiestaDTOStatoOneri.DA_PAGARE_FACOLTATIVO:
      return {
        color: theme?.colorError ?? '#ff0800',
        children: t('payment.da-pagare-dopo-invio', "Da Pagare dopo l'invio"),
      };
    case EnumRichiestaDTOStatoOneri.NESSUNO:
      return { hidden: true };
    default:
      return { children: text };
  }
}

export interface ISubmissionPaymentStateTagProps {
  state: RichiestaDTOStatoOneri;
}

/**
 * Tag che mostra lo stato degli oneri a livello di richiesta.
 */
export function SubmissionPaymentStateTag({
  state,
}: ISubmissionPaymentStateTagProps) {
  const theme = useTheme();
  return <StyledTag {...getTagOptions(state, theme)} />;
}
